"use strict";

exports.__esModule = true;
exports.ApmRoute = exports.withTransaction = void 0;

var _apmRum = require("@elastic/apm-rum");

var _getWithTransaction = require("./get-with-transaction");

var _getApmRoute = require("./get-apm-route");

var withTransaction = (0, _getWithTransaction.getWithTransaction)(_apmRum.apm);
exports.withTransaction = withTransaction;
var ApmRoute = (0, _getApmRoute.getApmRoute)(_apmRum.apm);
exports.ApmRoute = ApmRoute;